export default __webpack_public_path__ + "static/media/L'ENFANCE carre2.cb35f460.png";